import { ChangeEvent, ReactNode } from 'react';
import { Tab, Tabs, LinkItem } from '@occc/ui-design-system';
import { Container, PageHeader, useAppLayoutContextConsumer } from '@occc-app/design-system';

import { CONFIGURE_PAGE_STATE, AWARD_TYPES } from '../types';
import { getIsTargetTabEnabled, getPages } from '../utils';
import { messages } from '../messages';

type AwardCatalogFormWrapper = {
  children?: ReactNode;
  links: LinkItem[];
  title: string;
  pageState: CONFIGURE_PAGE_STATE;
  awardType?: AWARD_TYPES;
  setPageState?: (value: CONFIGURE_PAGE_STATE) => void;
  allowTabNavigation?: boolean;
};

export const AwardCatalogFormWrapper = ({
  title,
  children,
  links,
  awardType,
  pageState,
  setPageState,
  allowTabNavigation = true,
}: AwardCatalogFormWrapper) => {
  useAppLayoutContextConsumer(links);

  const isTargetTabEnabled = getIsTargetTabEnabled(awardType);
  const pages = awardType ? getPages(awardType) : [];
  const tabValue =
    pages.length > 0
      ? pages.indexOf(
          !isTargetTabEnabled && pageState === CONFIGURE_PAGE_STATE.TARGET
            ? CONFIGURE_PAGE_STATE.DESIGN
            : pageState,
        )
      : 0;

  const handleChange = (event: ChangeEvent, newValue: number) => {
    if (!setPageState) {
      return;
    }

    if (allowTabNavigation) {
      setPageState(pages[newValue]);
    }
  };

  return (
    <Container variant='md' includesPageHeader>
      <PageHeader title={title} subtitle={messages.subtitle} />
      <Tabs
        value={tabValue}
        onChange={handleChange}
        indicatorColor='secondary'
        textColor='secondary'
        sx={{ marginLeft: 2 }}
      >
        <Tab label='Configure' id={CONFIGURE_PAGE_STATE.CONFIGURE} />
        {isTargetTabEnabled && (
          <Tab disabled={!allowTabNavigation} label='Target' id={CONFIGURE_PAGE_STATE.TARGET} />
        )}
        <Tab disabled={!allowTabNavigation} label='Design' id={CONFIGURE_PAGE_STATE.DESIGN} />
        <Tab
          disabled={!allowTabNavigation}
          label='Schedule and Finalize'
          id={CONFIGURE_PAGE_STATE.FINALIZE}
        />
      </Tabs>
      {children}
    </Container>
  );
};
